import $ from 'jquery';
import inViewport from '../util/in-viewport';

export default class Animation {
  constructor() {
    this.modifyDOM();
    this.addEvents();
  }

  addEvents() {
    $(window).on('scroll', this.animateSection);
  }

  modifyDOM() {
    this.animateSection();
  }

  animateSection() {
    $('[data-in-view]').each((i, el) => {
      const $el = $(el);

      if ($el.hasClass('in-viewport')) {
        return;
      }

      if (inViewport($el[0], -150)) {
        $el.addClass(`in-viewport ${$el.data('in-view')}`);
      }
    });
  }
}
